const TOKEN_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  TOKEN_EXPIRY: 'tokenExpiry',
  OLD_JWT: 'jwt',
};

export const tokenStorage = {
  /**
   * Persist access token and expiry. expiresInSeconds is TTL from the API (e.g. signin response).
   */
  saveAccessToken: (accessToken, expiresInSeconds) => {
    const now = Date.now();
    const expiryTime = now + expiresInSeconds * 1000;

    localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, accessToken);
    localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
    localStorage.setItem(TOKEN_KEYS.TOKEN_EXPIRY, String(expiryTime));
    localStorage.setItem(TOKEN_KEYS.OLD_JWT, accessToken);
  },

  getAccessToken: () => {
    const accessToken = localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN);
    if (accessToken) return accessToken;
    return localStorage.getItem(TOKEN_KEYS.OLD_JWT);
  },

  getTokenExpiry: () => {
    const expiry = localStorage.getItem(TOKEN_KEYS.TOKEN_EXPIRY);
    return expiry ? parseInt(expiry, 10) : null;
  },

  isTokenExpired: () => {
    const expiry = tokenStorage.getTokenExpiry();
    if (!expiry) return true;
    return Date.now() >= expiry;
  },

  clearTokens: () => {
    console.log('[Token Storage] 🗑️ Clearing tokens', {
      timestamp: new Date().toISOString(),
      stack: new Error().stack,
    });
    localStorage.removeItem(TOKEN_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(TOKEN_KEYS.TOKEN_EXPIRY);
    localStorage.removeItem(TOKEN_KEYS.OLD_JWT);
  },

  isAuthenticated: () => {
    return !!tokenStorage.getAccessToken();
  },
};
